import SideMenu from "../../components/SideMenu";
import {
    Button, Checkbox,
    Paper,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead, TablePagination,
    TableRow,
    Toolbar,
    Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from "@mui/material";
import {grey} from "@material-ui/core/colors";
import {Formik} from "formik";
import CameraForm from "../../components/CameraForm";
import Input from "../../components/Input";
import DatePicker from "../../components/DatePicker";
import Select from "../../components/Select";
import date from "../../utils/date";
import MaskedInput from "react-text-mask/dist/reactTextMask";
import Autocomplete from "../../components/Autocomplete";
import api from "../../services/api";
import {usePlaces} from "../../hooks";
import SaveIcon from "@material-ui/icons/Save";
import Alert from "../../components/Alert";
import Popup from "../../components/Popup";
import {useHistory} from "react-router-dom";
import SettingsIcon from "@material-ui/icons/Settings";
import SearchIcon from "@material-ui/icons/Search";

export default function CustomizedGuestCreation() {
    const classes = useStyles();

    const history = useHistory();

    const [openGoBack, setOpenGoBack] = useState(false);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const [orgsSelect, setOrgsSelect] = useState([]);
    const [orgSearch, setOrgSearch] = useState("");
    const [selectedOrg, setSelectedOrg] = useState({});

    const [placesSearch, setPlacesSearch] = useState("");
    const [selectedPlace, setSelectedPlace] = useState({});
    const places = usePlaces({
        search: placesSearch,
    });

    const [openCustomizedFields, setOpenCustomizedFields] = useState(false);
    const [selectedFields, setSelectedFields] = useState(new Set());
    const [selectedDevices, setSelectedDevices] = useState(new Set());
    const [savedSelectedDevices, setSavedSelectedDevices] = useState([]);

    const allFields = [
        {label: "Data de nascimento", key: "birthday"},
        {label: "Orgão Emissor", key: "issuing_agency"},
        {label: "Tipo de Documento", key: "doc_type"},
        {label: "Número do Documento", key: "doc_number"},
        {label: "Sexo", key: "sex"},
        {label: "E-mail", key: "email"},
        {label: "Telefone", key: "phone"},
    ];

    const [searchDeviceInConfiguration, setSearchDeviceInConfiguration] = useState("");
    const [devicesConfiguration, setDevicesConfiguration] = useState([]);
    const [devicePageConfiguration, setDevicePageConfiguration] = useState(0);
    const [deviceTotalConfiguration, setDeviceTotalConfiguration] = useState(0);
    const [devicePaginationQuantityConfiguration, setDevicePaginationQuantityConfiguration] = useState(10);
    const [configurationFields, setConfigurationFields] = useState(new Set());

    const [customInputs, setCustomInputs] = useState([]);
    const [selectedCustomInputs, setSelectedCustomInputs] = useState(new Set());

    useEffect(() => {
        const findInputs = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        target: ['all', 'guest'],
                        page: 0,
                        limit: 30,
                    }
                });

                const {custom_inputs} = result.data;

                setCustomInputs(custom_inputs);
            } catch (err) {
                console.log(err);
            }
        };

        findInputs();
    }, []);

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    useEffect(() => {
        const findOrg = async () => {
            try {
                const result = await api.get('/organizational_structure/index', {
                    params: {
                        search: orgSearch,
                    }
                });

                const {orgs} = result.data;

                setOrgsSelect(orgs);
            } catch (err) {
                console.log(err.message);
            }
        };

        findOrg();
    }, [orgSearch]);

    useEffect(() => {
        const findDevices = async () => {
            try {
                const result = await api.get('/device_group/get_unrelated_devices', {
                    params: {
                        search: searchDeviceInConfiguration,
                        page: devicePageConfiguration,
                        limit: devicePaginationQuantityConfiguration,
                        type: null,
                    }
                });

                const {devices, count} = result.data;

                setDeviceTotalConfiguration(count);
                setDevicesConfiguration(devices);
            } catch (err) {
                console.log(err.message);
            }
        }

        findDevices();

    }, [openCustomizedFields, searchDeviceInConfiguration, devicePageConfiguration, devicePaginationQuantityConfiguration]);

    useEffect(() => {
        const findSelectedFilters = async () => {
            try {
                const {data, status} = await api.get('/user_customized_screen_configuration/list');
                if (status === 200) {
                    const commonFieldsWithNoDevice = data.fields.filter(t => t.deviceId === null && !t.name.startsWith("custom$"));
                    const customFieldsWithNoDevice = data.fields.filter(t => t.deviceId === null && t.name.startsWith("custom$"));
                    const fieldsWithDevice = data.fields.filter(t => t.deviceId !== null).map(t => t.deviceId);

                    setSavedSelectedDevices(fieldsWithDevice);
                    setSelectedFields(new Set(commonFieldsWithNoDevice.map(t => t.name)));
                    setSelectedCustomInputs(new Set(
                        customFieldsWithNoDevice
                            .map(t => {
                                const secondPart = t.name.split("$")[1];
                                const parsedValue = parseInt(secondPart, 10);
                                return isNaN(parsedValue) ? null : parsedValue;
                            })
                            .filter(value => value !== null)
                    ));
                    setSelectedDevices(new Set(fieldsWithDevice));
                }

            } catch (err) {
                console.log(err.message);
                setMessage({
                    open: true,
                    variant: 'error',
                    text: err.error,
                });
            }
        };

        findSelectedFilters();
    }, []);

    const initialFormValues = {
        name: '',
        birthday: null,
        sex: 'unknown',
        doc_type: '',
        doc_number: '',
        issuing_agency: '',
        email: '',
        phone: null,
        role: 'visitor',
        face_image: null,
        validation_date: date().format(),
        constant_visiting: false,
        visiting_location: null,
        notes: '',
        custom_inputs: [],
        only_allowed_by_related_access: false,
    }

    const saveUser = async (values, formik) => {
        try {
            const data = new FormData();
            data.append('face_image', values.face_image);

            const filteredValues = {...values};

            allFields.forEach(({key}) => {
                if (!selectedFields.has(key)) {
                    filteredValues[key] = initialFormValues[key]
                }
            });

            filteredValues.org_id = selectedOrg.id;
            filteredValues.visiting_location = selectedPlace.id;

            const userData = {
                ...filteredValues,
                visiting_days: {
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false
                },
                visiting_start: '00:00',
                visiting_end: '23:59',
                dependant_relationships: [],
                credentials: [],
                device_id: [...selectedDevices],
                camera_id: [],
                groups: []
            };

            userData.face_image = undefined;

            data.append('user_data', JSON.stringify(userData));

            const result = await api.post('/guest/create', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const {user} = result.data;
            formik.resetForm();
            setSelectedOrg({});
            setSelectedPlace({});

            formik.setSubmitting(false);

            setMessage({
                open: true,
                variant: 'success',
                text: `Visitante ${user.name} cadastrado(a) com sucesso!`,
            });

            setTimeout(() => setOpenGoBack(true), 1500);

        } catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    const PhoneMask = props => {
        const {inputRef, ...other} = props;

        return (
            <MaskedInput
                {...other}
                ref={ref => inputRef(ref ? ref.inputElement : null)}
                mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                placeholderChar={'_'}
                showMask
            />
        );
    };

    const formatUserData = values => {
        if (values.cpf)
            values.cpf = values.cpf.replace(/\D/g, '');

        if (values.rg)
            values.rg = values.rg.replace(/\D/g, '');

        if (values.phone)
            values.phone = values.phone.replace(/\D/g, '');
    };

    async function handleCloseCustomizedFields() {
        await saveConfigurationFields();
        const configurationFieldsArray = [...configurationFields];
        const commonFields = configurationFieldsArray.filter(t => !t.startsWith("custom$"));
        const customFields = configurationFieldsArray.filter(t => t.startsWith("custom$"))
            .map(t => {
                const secondPart = t.split("$")[1];
                const parsedValue = parseInt(secondPart, 10);
                return isNaN(parsedValue) ? null : parsedValue;
            }).filter(value => value !== null);


        setSelectedFields(new Set(commonFields));
        setSelectedCustomInputs(new Set(customFields));
        setSavedSelectedDevices([...selectedDevices]);

        const formattedDevices = [...selectedDevices].map(value => ({
            deviceId: value,
        }));

        setSelectedDevices(new Set(formattedDevices.map(v => v.deviceId)));

        setOpenCustomizedFields(false);
    }

    async function saveConfigurationFields() {
        try {
            const configurationFieldsStringArray = [...configurationFields].map(v => ({
                name: v,
                device_id: null
            }));

            const configurationDeviceFieldsStringArray = [...selectedDevices].map(value => ({
                deviceId: value,
                name: `device ${value}`
            }));

            configurationFieldsStringArray.push(...configurationDeviceFieldsStringArray);

            const {status} = await api.post('/user_customized_screen_configuration/save_configuration', {
                fields: configurationFieldsStringArray
            });

            if (status !== 201) {
                setMessage({
                    open: true,
                    variant: 'error',
                    text: `Erro para carregar as configurações customizadas da tela`,
                });
                return;
            }

            setMessage({
                open: true,
                variant: 'success',
                text: `Configurações salvas com sucesso`,
            });

        } catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: `Erro para salvar as configurações customizadas da tela: ${err.error}`
            });
        }
    }

    function handleFieldSelectOnChange(field) {
        setConfigurationFields(prev => {
            const newSet = new Set(prev);
            newSet.has(field) ? newSet.delete(field) : newSet.add(field);
            return newSet;
        });
    }

    return (
        <div className={classes.root}>
            <SideMenu/>
            <main className={classes.content}>
                <Toolbar/>
                <Grid container display="flex">
                    <Grid item md={4} xs={12}>
                        <Typography variant="h5" className={classes.title}>
                            Cadastro personalizado de visitante
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button
                            variant="contained"
                            form="guest-create"
                            color="primary"
                            className={classes.configButton}
                            onClick={() => {
                                if (!openCustomizedFields) {
                                    const customSelectedFields = [...selectedCustomInputs].map(t => "custom$" + t);
                                    const allSelectedFields = [...selectedFields, ...customSelectedFields];
                                    setConfigurationFields(new Set(allSelectedFields));
                                    setSelectedDevices(new Set(savedSelectedDevices));
                                }

                                setDevicePageConfiguration(0);
                                setDevicePaginationQuantityConfiguration(10);
                                setOpenCustomizedFields(!openCustomizedFields);
                            }}
                        >
                            <SettingsIcon/>
                        </Button>
                    </Grid>
                </Grid>
                <Paper elevation={3}>
                    {customizedForm()}
                </Paper>

                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}

                {popUpGoBack()}
                {popUpCustomizedFields()}
            </ main>
        </div>
    )

    function customizedForm() {
        return (
            <Formik
                initialValues={initialFormValues}
                validate={formatUserData}
                onSubmit={saveUser}
            >
                {({values, setFieldValue, handleChange, handleSubmit, isSubmitting}) => (
                    <form id="guest-create" onSubmit={handleSubmit} className={classes.form}>
                        <Grid container wrap="wrap" className={classes.containerForm}>
                            <Grid item xs={12} md={4}>
                                <CameraForm setFieldValue={setFieldValue} values={values}/>
                            </Grid>

                            <Grid item xs={12} md={8} className={classes.formSection}>
                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                    DADOS PESSOAIS
                                </Typography>

                                <Grid container wrap={"wrap"} rowSpacing={2} columnSpacing={1}>
                                    <Grid item xs={12} md={6}>
                                        <Input
                                            label="Nome completo"
                                            textFieldProps={{
                                                name: 'name',
                                                placeholder: 'Nome completo',
                                                onChange: handleChange,
                                                value: values.name,
                                                fullWidth: true,
                                                required: true,
                                            }}
                                        />
                                    </Grid>

                                    {selectedFields.has("birthday") &&
                                        <Grid item xs={12} md={3}>
                                            <DatePicker
                                                label="Data de nascimento"
                                                format="DD/MM/YYYY"
                                                id="date"
                                                value={values.birthday}
                                                placeholder="Data de nascimento"
                                                onChange={date => setFieldValue('birthday', date && date.format())}
                                                cancelLabel="cancelar"
                                                fullWidth={true}
                                            />
                                        </Grid>
                                    }

                                    {selectedFields.has("issuing_agency") &&
                                        <Grid item xs={12} md={3}>
                                            <Input
                                                label="Orgão Emissor"
                                                textFieldProps={{
                                                    name: 'issuing_agency',
                                                    placeholder: 'Orgão Emissor',
                                                    onChange: handleChange,
                                                    value: values.issuing_agency,
                                                    fullWidth: true,
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {selectedFields.has("doc_type") &&
                                        <Grid item xs={12} md={3}>
                                            <Select
                                                label="Tipo de Documento"
                                                options={[
                                                    {label: '-- Selecione --', value: ''},
                                                    {label: 'CPF', value: 'unknown'},
                                                    {label: 'RG', value: 'ic'},
                                                    {label: 'Passaporte', value: 'passport'},
                                                    {label: 'Outro', value: 'other'},
                                                ]}
                                                textFieldProps={{
                                                    name: 'doc_type',
                                                    onChange: handleChange,
                                                    fullWidth: true,
                                                    value: values.doc_type,
                                                    required: values.doc_number !== null && values.doc_number !== '',
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {selectedFields.has("doc_number") &&
                                        <Grid item xs={12} md={3}>
                                            <Input
                                                label="Número do Documento"
                                                textFieldProps={{
                                                    name: 'doc_number',
                                                    placeholder: 'Número do Documento',
                                                    onChange: handleChange,
                                                    value: values.doc_number,
                                                    fullWidth: true,
                                                    required: values.doc_type !== null && values.doc_type !== '',
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {selectedFields.has("sex") &&
                                        <Grid item xs={12} md={3}>
                                            <Select
                                                label="Sexo"
                                                options={[
                                                    {label: '-- Selecione --', value: 'unknown', id: 'unknown'},
                                                    {label: 'Masculino', value: 'male', id: 'male'},
                                                    {label: 'Feminino', value: 'female', id: 'female'},
                                                ]}
                                                textFieldProps={{
                                                    name: 'sex',
                                                    onChange: handleChange,
                                                    fullWidth: true,
                                                    value: values.sex,
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {selectedFields.has("email") &&
                                        <Grid item xs={12} md={3}>
                                            <Input
                                                label="E-mail"
                                                textFieldProps={{
                                                    name: 'email',
                                                    placeholder: 'E-mail',
                                                    onChange: handleChange,
                                                    value: values.email,
                                                    fullWidth: true,
                                                    required: false,
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {selectedFields.has("phone") &&
                                        <Grid item xs={12} md={3}>
                                            <Input
                                                label="Telefone"
                                                inputComponent={PhoneMask}
                                                textFieldProps={{
                                                    name: 'phone',
                                                    placeholder: 'Telefone',
                                                    onChange: handleChange,
                                                    value: values.phone,
                                                    fullWidth: true,
                                                    required: false,
                                                }}
                                            />
                                        </Grid>
                                    }

                                    <Grid item xs={12} md={4}>
                                        <Autocomplete
                                            label="Estrutura Organizacional"
                                            placeholder="Estrutura Organizacional"
                                            id="org_id"
                                            options={orgsSelect}
                                            getOptionLabel={({name}) => name || ''}
                                            onChange={(_, value) => setSelectedOrg(value)}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            onInputChange={(_, value) => setOrgSearch(value)}
                                            value={selectedOrg}
                                            required
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Autocomplete
                                            id="visiting_location"
                                            label={"Local de acesso"}
                                            options={places}
                                            getOptionLabel={({name}) => name || ''}
                                            onChange={(_, value) => setSelectedPlace(value)}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            onInputChange={(_, value) => setPlacesSearch(value)}
                                            value={selectedPlace}
                                            required
                                            fullWidth
                                        />
                                    </Grid>

                                    {customInputs.length > 0 && customInputsForm(values, setFieldValue, handleChange)}

                                    {devicesConfiguration.length > 0 && deviceSelectList()}

                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid container justifyContent="flex-end">
                            <Button
                                disabled={isSubmitting}
                                type="submit"
                                variant="contained"
                                form="guest-create"
                                color="primary"
                                endIcon={<SaveIcon/>}
                            >
                                {isSubmitting ? 'Salvando...' : 'Salvar dados'}
                            </Button>
                        </Grid>
                    </form>
                )}
            </Formik>
        );
    }

    function popUpGoBack() {
        return (
            <Popup
                openPopup={openGoBack}
                setOpenPopup={setOpenGoBack}
                title="Voltar a listagem de pessoas?"
                width="30%"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        style={{width: "40%", fontWeight: 700}}
                        size="large"
                        onClick={() => history.push("/pessoa")}
                    >
                        SIM
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{width: "40%", fontWeight: 700}}
                        size="large"
                        onClick={() => setOpenGoBack(false)}
                    >
                        NÃO
                    </Button>
                </div>
            </Popup>
        )
    }

    function popUpCustomizedFields() {
        return (
            <Popup
                openPopup={openCustomizedFields}
                setOpenPopup={handleCloseCustomizedFields}
                title="Configurar campos personalizados"
                width="90%"
            >
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableHead}>Campo</TableCell>
                                <TableCell className={classes.tableHead}>Selecionar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allFields.map((field) => (
                                <TableRow key={field.key}>
                                    <TableCell className={classes.tableBody}>{field.label}</TableCell>
                                    <TableCell className={classes.tableBody}>
                                        <Checkbox
                                            color='primary'
                                            type="checkbox"
                                            checked={configurationFields.has(field.key)}
                                            onChange={() => handleFieldSelectOnChange(field.key)}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {customInputs.map((input) => (
                                <TableRow key={'custom$' + input.id}>
                                    <TableCell className={classes.tableBody}>{input.name}</TableCell>
                                    <TableCell className={classes.tableBody}>
                                        <Checkbox
                                            color='primary'
                                            type="checkbox"
                                            checked={configurationFields.has('custom$' + input.id)}
                                            onChange={() => handleFieldSelectOnChange('custom$' + input.id)}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {deviceSelectList()}
            </Popup>
        )
    }

    function customInputsForm(values, setFieldValue, handleChange) {
        return (
            <>
                {customInputs.map((input, index) => {
                    if (index === 0 && values.custom_inputs.length === 0) {
                        // console.log('0 loop')
                        values.custom_inputs = customInputs

                    }

                    if (!selectedCustomInputs.has(input.id)) {
                        return (
                            <></>
                        );
                    }
                    // console.log("VAAAAAAAAAALUE", values.custom_inputs)
                    return (
                        <Grid key={index} item xs={12} md={4}>
                            {
                                input.type === "normal" ? (

                                    <Input
                                        label={input.name}
                                        textFieldProps={{
                                            id: `custom_inputs${index}.information`,
                                            name: `custom_inputs[${index}].information`,
                                            onChange: handleChange,
                                            value: values.custom_inputs[index].hasOwnProperty('information') ? values.custom_inputs[index]['information'] : '',
                                            fullWidth: true,
                                            required: input.is_required,
                                        }}

                                    />
                                ) : (

                                    <Autocomplete
                                        label={input.name}
                                        id={`custom_inputs${index}.information`}
                                        options={input.options?.length && input.options.map((option) => ({
                                            name: option,
                                            value: option,
                                            id: option
                                        }))}
                                        getOptionLabel={({name}) => name || ''}
                                        onChange={(_, value) => setFieldValue(`custom_inputs[${index}].information`, value)}
                                        getOptionSelected={(option, value) => (option.id === value.id)}
                                        /* onInputChange={(_, value) => setPersonTypeSearch(value)} */
                                        value={values.custom_inputs[index].hasOwnProperty('information') ? values.custom_inputs[index]['information'] : ''}
                                        required={input.is_required}
                                        fullWidth
                                    />
                                )
                            }
                        </Grid>
                    )
                })}
            </>
        );
    }

    function deviceSelectList() {
        return (
            <Grid container direction="column" style={{width: '100%',}}>
                <Typography variant="h5" className={classes.titleConfiguration}>
                    Dispositivos
                </Typography>

                <Input
                    label="Buscar"
                    icon={<SearchIcon style={{color: grey[400]}}/>}
                    iconPosition="start"
                    textFieldProps={{
                        placeholder: 'Buscar…',
                        fullWidth: true,
                        onChange: ({target}) => setSearchDeviceInConfiguration(target.value),
                    }}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableHead}>ID</TableCell>
                                <TableCell className={classes.tableHead}>Nome</TableCell>
                                <TableCell className={classes.tableHead}>Selecionar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {devicesConfiguration && devicesConfiguration.map((field) => (
                                <TableRow key={field.key}>
                                    <TableCell className={classes.tableBody}>{field.id}</TableCell>
                                    <TableCell className={classes.tableBody}>{field.name}</TableCell>
                                    <TableCell className={classes.tableBody}>
                                        <Checkbox
                                            color='primary'
                                            type="checkbox"
                                            checked={selectedDevices.has(field.id)}
                                            onChange={() => {
                                                setSelectedDevices(prev => {
                                                    const newSet = new Set(prev);
                                                    newSet.has(field.id) ? newSet.delete(field.id) : newSet.add(field.id);
                                                    return newSet;
                                                });
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 20, 30]}
                    component="div"
                    count={deviceTotalConfiguration}
                    rowsPerPage={devicePaginationQuantityConfiguration}
                    page={devicePageConfiguration}
                    labelDisplayedRows={({from, to, count}) => `${from}-${to} de ${count}`}
                    labelRowsPerPage="Registros por página"
                    onChangePage={(_, newPage) => setDevicePageConfiguration(newPage)}
                    onChangeRowsPerPage={({target}) => setDevicePaginationQuantityConfiguration(parseInt(target.value, 10))}
                />
            </Grid>
        );
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
    },
    containerForm: {
        paddingBottom: theme.spacing(2), // 👈 padding inferior
    },
    title: {
        color: grey[700],
        marginBottom: theme.spacing(3),
        fontSize: 28,
    },
    titleConfiguration: {
        color: grey[700],
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        fontSize: 28,
    },
    form: {
        padding: theme.spacing(3, 3),
    },
    formSection: {
        padding: theme.spacing(3)
    },
    formSectionTitle: {
        fontWeight: 'bold',
        color: grey[700],
        marginBottom: theme.spacing(1),
    },

    tableContainer: {
        maxHeight: '95%',
        width: '100%',
    },
    table: {
        width: '100%',
    },
    tableHead: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: grey[500],
    },
    configButton: {
        [theme.breakpoints.down('md')]: {
            width: "100%"
        }
    },
    tableBody: {
        color: grey[800],
        textAlign: 'center',
    },

}));
